import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Breadcrumb from "../../components/Breadcrumb";
import { Collapse, message, Switch, Input, Form } from "antd";
import HotelDropdownComponent from "../../components/HmgHotelDropdown/HotelDropdownComponent";
import {
  bulkfilemappingGetHotelData,
  bulkfilemappingUpdateBulkFile,
  bulkfilemappingDelete,
} from "../../store/actions/index";
import BulkFileMappingTable from "../../components/FileMapping/BulkFileMapping/ViewAndUpdate/BulkFileMappingTable";

const { Panel } = Collapse;

const breadcrumbElement = (
  <Breadcrumb
    routes={[
      { path: "/", breadcrumbName: "Dashboard" },
      {
        path: "/bulkfilemapping/view",
        breadcrumbName: "View and Update Bulk File Mapping",
      },
    ]}
  />
);
export class ViewBulkFileNames extends Component {
  static propTypes = {
    // prop: PropTypes
  };

  constructor(props) {
    super(props);

    this.state = {
      hmgmainSelect: undefined,
      hmgSelect: undefined,
      hotelSelect: undefined,
      file_mapping_data: [],
      editingKey: null,
      updatedRecord: {
        _id: undefined,
        bulk_source_file_name: "",
        status: false,
      },
    };
  }

  changeHotelHandler = (e) => {
    this.setState(
      {
        hotelSelect: e,
      },
      async () => {
        const result = await this.props.bulkfilemappingGetHotelData(e);
        this.setState({
          file_mapping_data: result,
          editingKey: null,
        });
      }
    );
  };

  changeHmgHandler = (e) => {
    this.setState({
      hmgSelect: e,
      hotelSelect: undefined,
      file_mapping_data: [],
    });
  };

  hmgmainChange = (e) => {
    this.setState({
      hmgmainSelect: e,
      hmgSelect: undefined,
      hotelSelect: undefined,
      file_mapping_data: [],
    });
  };

  setUpdateRecordParams = (index, value) => {
    let updatedRecord = { ...this.state.updatedRecord };
    updatedRecord[index] = value;
    this.setState({
      updatedRecord: updatedRecord,
    });
  };

  validateRecord = () => {
    if (this.state.updatedRecord.bulk_source_file_name.length === 0) {
      message.error("bulk source file name cannot be empty");
      return false;
    } else if (
      this.state.file_mapping_data.filter((el) => {
        if (
          typeof el.bulk_source_file_name === "string" &&
          el._id !== this.state.updatedRecord._id &&
          el.bulk_source_file_name.toLowerCase() ===
            this.state.updatedRecord.bulk_source_file_name.toLowerCase()
        ) {
          return true;
        }
      }).length > 0
    ) {
      message.error("bulk source file name already exist");
      return false;
    } else {
      return true;
    }
  };

  submitRecord = async () => {
    if (this.validateRecord()) {
      const result = await this.props.bulkfilemappingUpdateBulkFile({
        hotel_id: this.state.hotelSelect,
        ...this.state.updatedRecord,
      });
      if (result) {
        const updatedData = await this.props.bulkfilemappingGetHotelData(
          this.state.hotelSelect
        );
        this.setState({
          editingKey: null,
          updatedRecord: {
            _id: undefined,
            bulk_source_file_name: "",
            status: false,
          },
          file_mapping_data: updatedData,
        });
      }
    }
  };

  generateInputElement = (dataIndex) => {
    switch (dataIndex) {
      case "bulk_source_file_name":
        return (
          <Input
            placeholder="Bulk Source File Name"
            value={this.state.updatedRecord.bulk_source_file_name}
            onChange={(e) =>
              this.setUpdateRecordParams("bulk_source_file_name", e.target.value)
            }
          />
        );
      case "status":
        return (
          <Switch
            checked={this.state.updatedRecord.status}
            onChange={(e) => this.setUpdateRecordParams("status", e)}
          />
        );
    }
  };

  editableCell = ({
    editing,
    dataIndex,
    title,
    record,
    index,
    children,
    ...restProps
  }) => {
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            style={{
              margin: 0,
            }}
          >
            {this.generateInputElement(dataIndex)}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  deleteReport = async () => {
    // console.log('dlete triggered')
    const result = await this.props.bulkfilemappingDelete({
      ...this.state.updatedRecord,
      hotel_id: this.state.hotelSelect,
    });
    this.changeHotelHandler(this.state.hotelSelect);
  };

  setStateVals = (vals) => {
    this.setState(vals);
  };

  render() {
    return (
      <div>
        <div className="container_aa">
          <h3>View and Update Bulk File Mapping</h3>
          {breadcrumbElement}
        </div>
        <div className="container_ab">
          <Collapse defaultActiveKey={["1"]} expandIconPosition="right">
            <Panel key="1" header="Update Bulk File Mapping">
              <HotelDropdownComponent
                hmgmainSelect={this.state.hmgmainSelect}
                hmgmainChange={this.hmgmainChange}
                hmgSelect={this.state.hmgSelect}
                handleHmgChange={this.changeHmgHandler}
                hotelSelect={this.state.hotelSelect}
                handleHotelChange={this.changeHotelHandler}
              />
            </Panel>
          </Collapse>
          <Collapse defaultActiveKey={["2"]} expandIconPosition="end">
            <Panel key="2" header="Bulk File Mapping">
              <BulkFileMappingTable
                dataSource={this.state.file_mapping_data}
                updatedRecord={this.state.updatedRecord}
                editingKey={this.state.editingKey}
                setStateVals={this.setStateVals}
                submitRecord={this.submitRecord}
                deleteReport={this.deleteReport}
                editableCell={this.editableCell}
              />
            </Panel>
          </Collapse>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  bulkfilemappingGetHotelData: (id) =>
    dispatch(bulkfilemappingGetHotelData(id)),
  bulkfilemappingUpdateBulkFile: (record) =>
    dispatch(bulkfilemappingUpdateBulkFile(record)),
  bulkfilemappingDelete: (id) => dispatch(bulkfilemappingDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewBulkFileNames);
